import React from 'react';
import { Tooltip } from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";



export const ViewershipGridColumns = ({ hideActions, onEdit, onClone, onDelete }) => [
    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },
    {    field: 'id',
        headerName: 'ID',

        sortable: true,
        width: 60,
    },
    {
        field: 'externalId',
        headerName: 'External ID',

        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'viewDate',
        headerName: 'View Date',

        sortable: true,
        width: 150,
    },
    {
        field: 'views',
        headerName: 'Views',

        sortable: true,
        width: 150,
    },
    {
        field: 'viewedMinutes',
        headerName: 'Viewed Minutes',

        sortable: true,
        width: 150,
    },
    {
        field: 'rating',
        headerName: 'Rating',

        sortable: true,
        width: 150,
    },
    {
        field: 'source',
        headerName: 'Source',

        sortable: true,
        width: 150,
    },
    {
        field: 'productId',
        headerName: 'Product ID',

        sortable: true,
        width: 150,
    },
    {
        field: 'productName',
        headerName: 'Product Name',
        sortable: true,
        // editable: true,
        width: 300,
    },
    {
        field: 'episodeName',
        headerName: 'Episode Name',
        sortable: true,
        // editable: true,
        width: 250,
    },
    {
        field: 'seriesExternalId',
        headerName: 'Series ID',
        sortable: true,
        width: 80,

    },
    {
        field: 'seriesName',
        headerName: 'Series Name',
        sortable: true,
        width: 250,

    },

    {
        field: 'seasonExternalId',
        headerName: 'Season ID',
        sortable: true,
        // editable: true,
        width: 80,
    },
    {
        field: 'season',
        headerName: '#',
        sortable: true,
        // editable: true,
        width: 40,
    },
    {
        field: 'seasonName',
        headerName: 'Season Name',
        sortable: true,
        // editable: true,
        width: 250,
    },
    {
        field: 'platformId',
        headerName: 'Platform ID',

        sortable: true,
        width: 150,
    },

    {
        field: 'platformCode',
        headerName: 'Platform Code',

        sortable: true,
        width: 150,
    },
    {
        field: 'platformName',
        headerName: 'Platform Name',

        sortable: true,
        width: 150,
    },
    {
        field: 'service',
        headerName: 'Service',

        sortable: true,
        width: 150,
    },
    {
        field: 'platformTerritory',
        headerName: 'Platform Territory',

        sortable: true,
        width: 150,
    },
    {
        field: 'usageMarket',
        headerName: 'Usage Market',

        sortable: true,
        width: 150,
    },
    {
        field: 'platformOwner',
        headerName: 'Owner',

        sortable: true,
        width: 150,
    },
    {
        field: 'status',
        headerName: 'Status',
        sortable: true,
        width: 150,
    },
    {
        field: 'createdOn',
        headerName: 'createdOn',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'createdBy',
        headerName: 'createdBy',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'lastModifiedOn',
        headerName: 'lastModifiedOn',
        description: '',
        width: 100,
        hide: true
    },
    {
        field: 'lastModifiedBy',
        headerName: 'lastModifiedBy',
        description: '',
        width: 100,
        hide: true},
];
